import React from 'react';

import {Button, Stack} from '@mui/material';
import {AlertModal} from 'presentation/components';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {AutoSolEnum} from 'main/analytics/gaTagsEnum';
import {DiscardChangesModalProps} from './types';

const {title, headerTitle, description} =
	translations['pt-br'].privateFlow.requestAuthorizations.discardChangesModal;
const {cancel, confirm} = translations['pt-br'].commons;

export function DiscardChangesModal({open, setOpen, onConfirm}: DiscardChangesModalProps) {
	return (
		<AlertModal
			headerDataTagId={AutoSolEnum.AS_VISUALIZOU_MODAL_DESCARTE}
			closeBtnDataTagId={AutoSolEnum.AS_CLICK_FECHAR_MODAL_DESCARTE}
			variant="primary"
			title={title}
			description={description}
			open={open}
			onClose={() => setOpen(false)}
			headerTitle={headerTitle}
			footerContent={
				<Stack direction="row" gap={1} sx={{width: '100%'}}>
					<Button
						data-tag-id={AutoSolEnum.AS_CLICK_CANCELAR_DESCARTE}
						onClick={() => setOpen(false)}
						variant="outlined"
						size="large"
						fullWidth>
						{cancel}
					</Button>
					<Button
						data-tag-id={AutoSolEnum.AS_CLICK_CONFIRMAR_DESCARTE}
						onClick={onConfirm}
						variant="contained"
						size="large"
						fullWidth
						endIcon={<Icon name="success" />}>
						{confirm}
					</Button>
				</Stack>
			}
		/>
	);
}
